import * as React from 'react';
import { IconProps } from '../../dto/Interfaces/IIconProps';

const Instagram: React.FC<IconProps> = ({ color, size, style }) => {
  const colorId = color ? 'ff' : 'aa';
  return (
    <svg
      style={style}
      xmlns="http://www.w3.org/2000/svg"
      width={size ?? '20'}
      height={size ?? '20'}
      fill="none"
      viewBox="0 0 21 21"
      data-testid="instagram-icon"
    >
      <g clipPath={`url(#clip0Instagramcc${colorId})`}>
        <path
          fill={`url(#paint0_linear_instagramff${colorId})`}
          d="M10.988 4.878a5.13 5.13 0 10.008 10.26 5.13 5.13 0 00-.008-10.26zm0 8.46a3.33 3.33 0 113.333-3.313 3.329 3.329 0 01-3.333 3.304v.008zm6.534-8.675a1.202 1.202 0 11-.087-.45c.059.147.089.304.087.463v-.013zm2.933-1.21a5.11 5.11 0 00-2.92-2.928A7.249 7.249 0 0015.11.062C14.044.012 13.7 0 10.98 0 8.256 0 7.926 0 6.848.062a7.249 7.249 0 00-2.404.463 5.11 5.11 0 00-2.92 2.924 7.295 7.295 0 00-.467 2.445C1.012 6.96 1 7.3 1 10.024c0 2.727 0 3.053.058 4.131a7.32 7.32 0 00.467 2.425 5.11 5.11 0 002.92 2.924 7.457 7.457 0 002.424.434C7.935 19.988 8.278 20 11 20c2.722 0 3.057 0 4.13-.062a7.46 7.46 0 002.425-.463 5.111 5.111 0 002.92-2.924 7.32 7.32 0 00.467-2.425c.046-1.065.058-1.404.058-4.13s0-3.053-.058-4.13a7.296 7.296 0 00-.487-2.4v-.013zM19.12 14.031a5.459 5.459 0 01-.343 1.855 3.105 3.105 0 01-.748 1.16c-.323.331-.715.587-1.148.748a5.559 5.559 0 01-1.855.343c-1.053.046-1.371.058-4.04.058-2.668 0-2.982 0-4.035-.058a5.558 5.558 0 01-1.855-.343 3.143 3.143 0 01-1.148-.747 3.107 3.107 0 01-.747-1.153 5.457 5.457 0 01-.343-1.854c-.05-1.054-.058-1.368-.058-4.036 0-2.668 0-2.982.058-4.04.006-.633.122-1.26.343-1.854a3.09 3.09 0 01.747-1.148c.323-.331.715-.586 1.148-.748a5.56 5.56 0 011.855-.343c1.053-.05 1.371-.058 4.036-.058 2.664 0 2.986 0 4.04.058a5.56 5.56 0 011.854.343c.433.162.825.417 1.148.748.332.322.588.714.748 1.148.22.594.336 1.221.343 1.854.05 1.058.057 1.372.057 4.04s-.008 2.987-.057 4.04v-.013z"
        />
      </g>
      <defs>
        {color ? (
          <linearGradient id={`paint0_linear_instagramff${colorId}`} x1="2.677" x2="19.302" y1="18.323" y2="1.694" gradientUnits="userSpaceOnUse">
            <stop stopColor={color || '#FFFFFF'} />
            <stop offset="1" stopColor={color || '#FFFFFF'} />
          </linearGradient>
        ) : (
          <linearGradient id={`paint0_linear_instagramff${colorId}`} x1="2.677" x2="19.302" y1="18.323" y2="1.694" gradientUnits="userSpaceOnUse">
            <stop stopColor={color || '#FDD91D'} />
            <stop offset="0.05" stopColor={color || '#FDD91D'} />
            <stop offset="0.5" stopColor={color || '#EC1C24'} />
            <stop offset="0.95" stopColor={color || '#A43A94'} />
            <stop offset="1" stopColor={color || '#A43A94'} />
          </linearGradient>
        )}

        <clipPath id={`clip0Instagramcc${colorId}`}>
          <path fill={color || '#fff'} d="M0 0H20V20H0z" transform="translate(.996 .4)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Instagram;
